import { mapGetters, mapActions } from 'vuex'

export const Computed = {
  ...mapGetters('actions', ['cachedActions', 'selectedAction']),
}

export const Methods = mapActions('actions', [
  'fetchActions',
  'selectAction',
  'updateAction',
  'deleteAction',
])
